import type { ErrorCollection } from '@ps/web-core-store';
import type { FieldState, FormApi } from 'final-form';

import type { Validator } from '../types';
import { mapErrorCodes } from '../utils/mapErrorCodes';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const serverFieldErrMsgWarning =
  (error: ErrorCollection | null, removeWizardError: () => void, form: FormApi): Validator =>
  (value: string, values: any, meta?: FieldState<any>) => {
    if (meta?.data) {
      if (value && error?.fieldErrors?.length) {
        const index = error.fieldErrors.findIndex(({ fieldName }) => meta.name.includes(fieldName));

        if (value === meta.initial && meta.data && index > -1) {
          const { code, defaultMessage } = error.fieldErrors[index];
          const message = defaultMessage || mapErrorCodes(code || '');
          if (!meta.data.warning && message) {
            form?.mutators?.setFieldData(meta.name, {
              warning: message
            });
            meta.focus();
          }
          if (!meta.data.samePageError) {
            removeWizardError();
          }

          return { valid: true };
        }
      }

      delete meta.data.warning;
    }

    return { valid: true };
  };
